module.exports = __webpack_public_path__ + "static/media/e-login.3bc48949.png";